import fc from "@/firebaseConfig";
import firebase from "firebase/app";
// import algoliasearch from "algoliasearch";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
const _ = require("lodash");


const removeDuplicatesWithSameId = (inputArray) => {
  const idSet = new Set(); // To track encountered IDs
  const resultArray = [];

  for (const item of inputArray) {
    // Assuming each item has an 'id' property
    const itemId = item.objectID;

    if (!idSet.has(itemId)) {
      // If the ID is not in the set, add it to the result and the set
      idSet.add(itemId);
      resultArray.push(item);
    }
  }

  return resultArray;
}

const sortByField = (arr, field, order) => {
  const multiplier = order === "desc" ? -1 : 1;
  const compareFunction = (a, b) => {
    const aValue = a[field];
    const bValue = b[field];

    if (typeof aValue === "string" && typeof bValue === "string") {
      return multiplier * aValue.localeCompare(bValue);
    }

    return multiplier * (aValue - bValue);
  };

  return [...arr].sort(compareFunction);
};

function isNumeric(input) {
  return /^[0-9]+$/.test(input);
}

function adjustDate(inputDateString) {
  const inputDate = new Date(inputDateString);
  const localOffset = inputDate.getTimezoneOffset() * 60000;
  const adjustedInputDate = new Date(inputDate.getTime() - localOffset);
  const dateStr = adjustedInputDate.toISOString();
  return dateStr;
}

function removeDuplicatesAndEmptyStrings(arr) {
  // Use a Set to store unique values
  const uniqueValues = new Set();

  // Use the filter method to iterate through the array
  const filteredArray = arr.filter((item) => {
    if (item === '') {
      // Exclude empty strings
      return false;
    } else if (!uniqueValues.has(item)) {
      // Include non-empty values not seen before
      uniqueValues.add(item);
      return true;
    }
    return false; // Exclude duplicates
  });

  return filteredArray;
}

const getFormatedKeywordList = (_keyword, _prefixes) => {
  _prefixes = removeDuplicatesAndEmptyStrings(_prefixes)
  // console.log("_prefixes formated ==> ", _prefixes)
  _keyword = _keyword.toUpperCase();
  let _formatedKeywordList = [
    _keyword,
    ...(_prefixes.some((prefix) => _keyword.startsWith(prefix))
      ? ""
      : _prefixes.map((prefix) => prefix + _keyword)),
  ];

  // console.log("_formatedKeywordList:: ", _formatedKeywordList)
  return _formatedKeywordList;
};

function getDateBefore(inputDateString) {
  const millisecondsBefore = 12 * 60 * 60 * 1000; // One day in milliseconds
  const inputDate = new Date(inputDateString);
  const adjustedDate = new Date(inputDate.getTime() - millisecondsBefore);
  const dateStr = adjustedDate.toISOString();
  return dateStr;
}

export default {
  namespaced: true,
  state: {
    list: [],
    listOrigin: [],
    searchField: "objectID",
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    docList: [],
    summaryReport: {},
    orderBySelect: { key: "ED.IssueDateTime", value: "desc" },
    valueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
    selectedList: [],
    summaryAll: null,
    showPaginationTemplate: true,
    mDocsDocListUnsubscribeObject: null,
    mDocsSummaryAllUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setFromDate(state, val) {
      state.fromDate = val;
    },
    setToDate(state, val) {
      state.toDate = val;
    },
    setSearchField(state, val) {
      state.searchField = val;
    },
    setCompaniesDocs(state, val) {
      state.list = val;
    },
    setPage(state, val) {
      state.page = val;
    },
    setKeyword(state, val) {
      state.keyword = val;
    },
    setListOrigin(state, val) {
      state.listOrigin = val;
    },
    setEmptyList(state, val) {
      state.emptyList = val;
    },
    setStackPage(state, val) {
      state.stackPage = val;
    },
    setCurrentPageAlgolia(state, val) {
      state.currentPageAlgolia = val;
    },
    setDocList(state, val) {
      state.docList = val;
    },
    setSummaryReport(state, val) {
      state.summaryReport = val;
    },
    setOrderBySelect(state, val) {
      state.orderBySelect = val;
    },
    setValueFilterList(state, val) {
      state.valueFilterList = val;
    },
    setSelectedList(state, val) {
      state.selectedList = val;
    },
    setSummaryAll(state, val) {
      state.summaryAll = val;
    },
    setShowPaginationTemplate(state, val) {
      state.showPaginationTemplate = val;
    },
  },
  actions: {
    updateDocs({ commit }, val) {
      commit("setCompaniesDocs", val);
    },
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      // console.log("documentType:::::::: ", documentType)

      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }

      return "";
    },
    setLoading({ commit }, val) {
      commit("setLoading", val);
    },
    setFromDate({ commit }, val) {
      commit("setFromDate", val);
    },
    setToDate({ commit }, val) {
      commit("setToDate", val);
    },
    setSearchField({ commit }, val) {
      commit("setSearchField", val);
    },
    async setDocsData({ commit }, data) {
      if (data && data.length) {
        let pageLimit = localStorage.getItem("pageLimit");
        if (pageLimit === "auto") {
          pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
        } else {
          pageLimit = parseInt(pageLimit) || 10;
        }

        let docsList = data;
        let docs = [];
        for (let doc of docsList) {
          doc = doc.node;
          let timeSignedXml = null;
          if (doc.timeSignedXml) {
            timeSignedXml = moment(doc.timeSignedXml);
          }
          //update condition
          var gSchemeID = "";
          if (doc.buyerTaxID.length == 13 && doc.buyerBranchID.length == 5) {
            gSchemeID = "TXID";
          }
          if (doc.buyerTaxID.length == 13 && doc.buyerBranchID == "") {
            gSchemeID = "NIDN";
          }
          if (
            (doc.buyerTaxID == "" || doc.buyerTaxID == "N/A") &&
            doc.buyerBranchID == ""
          ) {
            gSchemeID = "OTHR";
          }

          let d = {
            "@BuyerBranchID": doc.buyerBranchId,
            "@DocType": doc.docType,
            "@DownloadedXml": doc.downloadedXml,
            "ED.IssueDateTime": doc.edIssueDateTime,
            "@Errors": JSON.parse(JSON.parse(doc.errors)),
            "@MailSent": doc.mailSent,
            objectID: doc.objectId,
            "SCTT.AHTA.BTP.ID": doc.scttAhtaBtpId,
            //add new
            "SCTT.AHTA.BTP.STR.schemeID": gSchemeID,
            //add new
            "SCTT.AHTA.BTP.Name": doc.scttAhtaBtpName,
            "SCTT.AHTA.BTP.STR.ID": doc.scttAhtaBtpStrId,
            "SCTT.AHTS.STSHMS.GrandTotalAmount":
              doc.scttAhtsStshmsGrandTotalAmount,
            "SCTT.AHTS.STSHMS.TaxBasisTotalAmount":
              doc.scttAhtsStshmsTaxBasisTotalAmount,
            "SCTT.AHTS.STSHMS.TaxTotalAmount": doc.scttAhtsStshmsTaxTotalAmount,
            "@SignedPdfUrl": doc.signedPdfUrl,
            "@SignedXmlUrl": doc.signedXmlUrl,
            "@TimeSignedXml": timeSignedXml,
            "@UnsignedPdfUrl": doc.unsignedPdfUrl,
            id: doc.objectId,
            "@BuyerEmail": doc.buyerEmail,
          };
          docs.push(d);
        }
        let startVisible = docs[0];
        let lastVisible = docs[docs.length - 1];

        let objectTmp = {
          first: _.cloneDeep(startVisible),
          last: _.cloneDeep(lastVisible),
        };
        let stackPage = _.cloneDeep(this.state.docs.stackPage);
        stackPage[this.state.docs.page] = objectTmp;

        commit("setStackPage", stackPage);
        commit("setCompaniesDocs", docs);
        commit("setListOrigin", docs);
        commit("setEmptyList", false);
        commit("setLoading", false);
      } else {
        commit("setCompaniesDocs", []);
        commit("setListOrigin", []);
        commit("setEmptyList", true);
      }
    },
    async getList({rootState, commit, dispatch}, {id, isNextPage}) {
      commit("setLoading", true);

      const pageLimitForKeyword = 4000;

      // console.log("fromDate ==> ", this.state.docs.fromDate);
      // console.log("toDate ==> ", this.state.docs.toDate);

      // console.log("HIII GETLIST TRIGGER::");

      let pageLimit = localStorage.getItem("pageLimit");
      if (pageLimit === "auto") {
        pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
      } else {
        pageLimit = parseInt(pageLimit) || 10;
      }


      let documentType = await dispatch("getDocumentType");
      let documentTypeNumber = getDocumentTypeKey(documentType);
      let selectedBranch = rootState.companies.selectedBranch;

      // console.log("KEYWORD TRIGGERED!!");

      let query = fc.companies.doc(id).collection("Docs");
      let {keyword} = this.state.docs;

      let combinedResults = [];

      if (selectedBranch) {
        query = query.where("@SellerBranchID", "==", selectedBranch);
      }

      if (documentTypeNumber) {
        query = query.where("@DocType", "==", documentTypeNumber);
      }

      // let countItem = 0;

      if (keyword) {
        const _searchField = new firebase.firestore.FieldPath(
          this.state.docs.searchField
        );

        // console.log("keyword type ==> ", typeof(keyword))
        // console.log("_searchField ==> ", this.state.docs.searchField)

        var cleanKeyword = keyword
          .replace(/[,.]/g, "")
          .replace(/\s/g, "")
          .trim();

        let _keyword;
        let _endKey;

        if (
          isNumeric(cleanKeyword) &&
          this.state.docs.searchField !== "@BuyerBranchID" &&
          this.state.docs.searchField !== "SCTT.AHTA.BTP.ID" &&
          this.state.docs.searchField !== "SCTT.AHTA.BTP.STR.ID" &&
          this.state.docs.searchField !== "objectID"
        ) {
          _keyword = Number(cleanKeyword);
          _endKey = _keyword;
          // console.log("keyword type number ==> ", typeof(_keyword))
          // console.log("keyword type number ==> ", _keyword)
        } else {
          _keyword =
            this.state.docs.searchField == "objectID"
              ? keyword.trim().toUpperCase()
              : keyword.trim();
          _endKey = _keyword + "\uf8ff";
          // console.log("keyword type string ==> ", typeof(_keyword))
        }

        // console.log("_keyword::: ", _keyword);
        // console.log("_endKey::: ", _endKey);
        // console.log("typeof(_keyword)::: ", typeof _keyword);

        // if(this.state.docs.searchField == "objectID"){

        // }
        let summaryAll = this.state.docs.summaryAll
        let prefixes = []
        // console.log("documentType ", documentType);
        // console.log("summaryAll prefixes ==> ", summaryAll?.prefixes);
        switch (documentType.toLowerCase()) {
          case "ab":
            prefixes = summaryAll?.prefixes?.ab ? summaryAll?.prefixes?.ab : []
            break;
          case "cr":
            prefixes = summaryAll?.prefixes?.cr ? summaryAll?.prefixes?.cr : []
            break;
          case "dr":
            prefixes = summaryAll?.prefixes?.dr ? summaryAll?.prefixes?.dr : []
            break;
          case "re":
            prefixes = summaryAll?.prefixes?.re ? summaryAll?.prefixes?.re : []
            break;
          case "rt":
            prefixes = summaryAll?.prefixes?.rt ? summaryAll?.prefixes?.rt : []
            break;
          case "tx":
            prefixes = summaryAll?.prefixes?.tx ? summaryAll?.prefixes?.tx : []
            break;
          default:
            prefixes = summaryAll?.prefixes ? Object.values(summaryAll?.prefixes)?.reduce((acc, value) => acc?.concat(value), []) : [];
            // console.log("prefixes ========= ", prefixes)
            break;
        }
        const searhKeyList = getFormatedKeywordList(_keyword, prefixes);

        // console.log("searchKeylist:: ", searhKeyList);

        // Use a for loop to search for results for each keyword in searchKeyList
        for (const keyword of searhKeyList) {
          // Append "\uf8ff" to the keyword to use it as the end key
          const endKey = `${keyword}\uf8ff`;

          // Create a new query for each keyword
          const keywordQuery = query
            .where(_searchField, ">=", keyword)
            .where(_searchField, "<=", endKey)
            .limit(pageLimitForKeyword);

          // Execute the query and push the results into the combinedResults array
          const results = await keywordQuery.get(); // Assuming you are using an async database query method

          // Combine results
          results.forEach((doc) => {
            if (doc.exists) {
              const data = doc.data();
              const _id = doc.id;
              combinedResults.push({...data, id: _id});
            }
          });
        }

        // console.log("combinedResults:: ", combinedResults);

        query = query
          .where(_searchField, ">=", _keyword)
          .where(_searchField, "<=", _endKey)
          .limit(pageLimitForKeyword);
      }

      if (this.state.docs.fromDate) {
        const _searchField = new firebase.firestore.FieldPath(
          this.state.docs.searchField
        );

        const _keyword = getDateBefore(this.state.docs.fromDate);

        if (this.state.docs.toDate) {
          const _endKey = adjustDate(this.state.docs.toDate);
          // console.log("dateKeyFrom::: ", _keyword);
          // console.log("dateKeyTo::: ", _endKey);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimitForKeyword);
        } else {
          const _endKey = adjustDate(this.state.docs.fromDate);
          // console.log("dateKeyFrom::: ", _keyword);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimitForKeyword);
        }

        // console.log("date triggered");
      }


      let downloaded =
        this.state.docs.valueFilterList.includes("@DownloadedXml");
      let cancelled = this.state.docs.valueFilterList.includes("cancelled");
      let notDownload =
        this.state.docs.valueFilterList.includes("not-download");
      let docCancelled = cancelled && !notDownload && !downloaded;

      if (
        this.state.docs.orderBySelect &&
        this.state.docs.orderBySelect["key"] &&
        this.state.docs.orderBySelect["key"] !== "ID" &&
        !keyword &&
        !this.state.docs.fromDate &&
        !this.state.docs.toDate
      ) {
        query = query.orderBy(
          new firebase.firestore.FieldPath(
            this.state.docs.orderBySelect["key"]
          ),
          this.state.docs.orderBySelect["value"]
        );
      }


      if (
        this.state.docs.valueFilterList.length > 0 &&
        (!keyword || (!this.state.docs.fromDate && !this.state.docs.toDate))
      ) {
        if (downloaded && !notDownload) {
          query = query.where("@DownloadedXml", "==", true);
        }
        if (notDownload && !downloaded) {
          query = query.where("@DownloadedXml", "==", false)
        }

        if (docCancelled) {
          query = query.where("@DocData.docStatus", "==", "C");
        }


      }


      //if page is more than 1 means when nextPage click
      if (this.state.docs.page > 1 && (!keyword || (!this.state.docs.fromDate && !this.state.docs.toDate))) {
        let listTmpPage;
        if (isNextPage) {
          //if page press next
          listTmpPage = this.state.docs.stackPage[this.state.docs.page - 1];
          query = query.startAfter(listTmpPage["last"]).limit(pageLimit);
        } else {
          //if press previous
          listTmpPage = this.state.docs.stackPage[this.state.docs.page];
          query = query.startAt(listTmpPage["first"]).limit(pageLimit);
        }
      } else if (pageLimit) {
        query =
          keyword
            ? query.limit(pageLimitForKeyword)
            : query.limit(pageLimit);
      }

      if (this.state.mDocsDocListUnsubscribeObject) {
        this.state.mDocsDocListUnsubscribeObject();
      }


      if (combinedResults.length > 0) {

        // console.log("Combine so cool")
        //If there is filter downloaded xml
        const {valueFilterList, orderBySelect} = this.state.docs;
        const downloaded = valueFilterList.includes("@DownloadedXml");
        const notDownload = valueFilterList.includes("not-download");

        if (
          downloaded &&
          !notDownload &&
          (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
        ) {
          combinedResults = this.state.docs.list.filter(
            (item) => item["@DownloadedXml"]
          );
        } else if (
          notDownload &&
          !downloaded &&
          (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
        ) {
          combinedResults = this.state.docs.list.filter(
            (item) => !item["@DownloadedXml"]
          );
        }

        if (
          orderBySelect &&
          orderBySelect.key &&
          orderBySelect.key !== "ID" &&
          (keyword || this.state.docs.fromDate || this.state.docs.toDate)
        ) {
          // console.log("sort local")
          const {key, value} = orderBySelect;
          combinedResults = sortByField(combinedResults, key, value);
        }

        // console.log("documentsArray:: ", documentsArray.length);

        if (
          this.state.docs.page > 1 &&
          (keyword || this.state.docs.fromDate || this.state.docs.toDate)
        ) {
          // console.log("listOrigin :: ,", documentsArray);
          const {key, value} = orderBySelect;
          commit(
            "setCompaniesDocs",
            sortByField(
              [...this.state.docs.list, ...combinedResults],
              key,
              value
            )
          );

          // console.log("COMPANY LIST DOC::::::::: ", this.state.docs.list)

        } else {
          commit("setCompaniesDocs", combinedResults);
        }
        commit("setCompaniesDocs", combinedResults.slice(0, 10));
        commit("setListOrigin", combinedResults);
        commit("setEmptyList", false);
        commit("setLoading", false);
        return
      }

      this.state.mDocsDocListUnsubscribeObject = combinedResults.length === 0 && query.onSnapshot(
        (documents) => {
          let documentsArray = [];
          // console.log("documents.size der:::: ", documents.size);
          if (documents.size !== 0) {
            for (const doc of documents.docs) {
              let document = doc.data();
              document.id = doc.id;
              documentsArray.push(document);
            }

            let startVisible = documents.docs[0];
            let lastVisible = documents.docs[documents.docs.length - 1];

            let objectTmp = {
              first: _.cloneDeep(startVisible),
              last: _.cloneDeep(lastVisible),
            };
            let stackPage = _.cloneDeep(this.state.docs.stackPage);
            stackPage[this.state.docs.page] = objectTmp;

            //If there is filter downloaded xml
            const {valueFilterList, orderBySelect} = this.state.docs;
            const downloaded = valueFilterList.includes("@DownloadedXml");
            const notDownload = valueFilterList.includes("not-download");

            if (
              downloaded &&
              !notDownload &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => item["@DownloadedXml"]
              );
            } else if (
              notDownload &&
              !downloaded &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => !item["@DownloadedXml"]
              );
            } else if (
              docCancelled &&
              (keyword || (this.state.docs.fromDate && this.state.docs.toDate))
            ) {
              documentsArray = this.state.docs.list.filter(
                (item) => item['@DocData']['docStatus'] == 'C'
              );
            }

            if (
              orderBySelect &&
              orderBySelect.key &&
              orderBySelect.key !== "ID" &&
              (keyword || this.state.docs.fromDate)
            ) {
              const {key, value} = orderBySelect;
              documentsArray = sortByField(documentsArray, key, value);
            }

            // console.log("documentsArray:: ", documentsArray.length);

            commit("setStackPage", stackPage);
            if (
              this.state.docs.page > 1 &&
              (keyword || this.state.docs.fromDate || docCancelled)
            ) {
              // console.log("listOrigin :: ,", documentsArray);
              const {key, value} = orderBySelect;
              commit(
                "setCompaniesDocs",
                sortByField(
                  [...this.state.docs.list, ...documentsArray],
                  key,
                  value
                )
              );
              // console.log("Yeeee")
            } else {
              // console.log("Yooo")
              commit("setCompaniesDocs", removeDuplicatesWithSameId(documentsArray));
            }
            // console.log("documentsArrayDer ==> ", documentsArray);
            // console.log("documentsArrayDerFormat ==> ", removeDuplicatesWithSameId(documentsArray).map((item)=> item.objectID));
            commit("setListOrigin", documentsArray);
            commit("setEmptyList", false);
          } else if (
            documents.size === 0 &&
            (keyword || this.state.docs.fromDate || this.state.docs.toDate) &&
            this.state.docs.page > 1
          ) {
            commit("setCompaniesDocs", removeDuplicatesWithSameId(this.state.docs.list));
            commit("setListOrigin", []);
          } else {
            commit("setCompaniesDocs", []);
            commit("setListOrigin", []);
            commit("setEmptyList", true);
          }
          commit("setLoading", false);
        }
      );

    },
    getDocListUnsubscribe() {
      if (this.state.mDocsDocListUnsubscribeObject) {
        this.state.mDocsDocListUnsubscribeObject();
        this.state.mDocsDocListUnsubscribeObject = null;
      }
    },
    getListByMonth(
      { commit },
      { companyID, startDate, endDate, reportBranchType }
    ) {
      commit("setLoading", true);
      const fieldQuery = new firebase.firestore.FieldPath(
        "ED.IssueDateTime.Timestamp"
      );
      const docs = fc.companies.doc(companyID).collection("Docs");
      let query = docs;

      query = query.where("@DownloadedXml", "==", true);

      if (startDate && endDate) {
        query = query
          .where(fieldQuery, ">=", new Date(startDate))
          .where(fieldQuery, "<=", new Date(endDate));
      }

      if (reportBranchType) {
        query = query.where("@SellerBranchID", "==", reportBranchType);
      }

      query.get().then(function (docs) {
        let docList = [];
        let summary = {
          sumTaxableAmount: 0.0,
          sumTaxableTax: 0.0,
          sumTaxableAllAmount: 0.0,

          sumAmount: 0.0, // รวมมูลค่าสินค้าที่ไม่มีภาษี
          sumTax: 0.0, // รวมภาษีที่ไม่มีภาษี (เป็น 0 เสมอ)
          sumAllAmount: 0.0, // รวมยอดสุดท้ายที่ไม่มีภาษี

          grandTotalAmount: 0.0, // รวมมูลค่าสินค้าทั้งหมด
          grandTotalTax: 0.0, // รวมภาษีทั้งหมด
          grandTotalAllAmount: 0.0, // รวมยอดสุดท้ายทั้งหมด
        };
        docs.forEach((doc) => {
          let docData = doc.data();
          docData.id = doc.id;

          // case 4 ใบลดหนี้
          if (docData["@DocType"] === 4) {
            docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.GrandTotalAmount"] *= -1;
          }
          let docStatus = docData['@DocData']['docStatus'];
          docList.push(docData);
          if (docStatus !== 'C' && docData["@DocType"] !== 5 && docData["@DocType"] !== 7 && docData["@DocType"] !== 4) {
            summary.grandTotalAmount += docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
            summary.grandTotalTax += docData["SCTT.AHTS.STSHMS.TaxTotalAmount"];
            summary.grandTotalAllAmount += docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];

            if (docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] && docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] !== "0") {
              summary.sumTaxableAmount += docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
              summary.sumTaxableTax += docData["SCTT.AHTS.STSHMS.TaxTotalAmount"];
              summary.sumTaxableAllAmount += docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];
            } else {
              summary.sumAmount += docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
              summary.sumAllAmount += docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];
            }
          }
        });
        commit("setDocList", docList);
        commit("setLoading", false);
        commit("setSummaryReport", summary);
      });
    },
    updatePage({ commit }, { page }) {
      commit("setPage", page);
    },
    updateKeyword({ commit }, { keyword }) {
      // commit("setCurrentPageAlgolia", 0);
      commit("setKeyword", keyword);
    },
    resetKeyword({ commit }) {
      commit("setKeyword", "");
    },
    setOrderBySelect({ commit }, { orderBySelect }) {
      // console.log("orderBySelect::: ", orderBySelect);
      commit("setOrderBySelect", orderBySelect);
    },
    setValueFilterList({ commit }, { valueFilterList }) {
      commit("setValueFilterList", valueFilterList);
    },
    setSelectedList({ commit }, { selectedList }) {
      commit("setSelectedList", selectedList);
    },
    getSummaryAll({ commit }, { companyId }) {
      if (this.state.mDocsSummaryAllUnsubscribeObject) {
        this.state.mDocsSummaryAllUnsubscribeObject();
      }
      this.state.mDocsSummaryAllUnsubscribeObject = fc.companies
        .doc(companyId)
        .collection("Summaries")
        .doc("all")
        .onSnapshot(function (allSummaries) {
          commit("setSummaryAll", allSummaries.data());
        });
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mDocsSummaryAllUnsubscribeObject) {
        this.state.mDocsSummaryAllUnsubscribeObject();
        this.state.mDocsSummaryAllUnsubscribeObject = null;
      }
    },
    setShowPaginationTemplate({ commit }, { val }) {
      commit("setShowPaginationTemplate", val);
    },
  },
};

export const docsQuery = gql`
  query docs(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $companyId: String!
    $order: String
    $search: String
    $issueDateTimeRange: [DateTime]
    $objectId: String
    $scttAhtaBtpId: String
    $buyerBranchId: String
    $typeLineTotal: String
    $lineTotal: [Float]
    $typeTaxTotal: String
    $taxTotal: [Float]
    $typeGrandTotal: String
    $grandTotal: [Float]
    $timeSignedXmlRange: [DateTime]
    $docType: String
    $downloadedXml: Boolean
    $signSuccess: Boolean
    $hasError: Boolean
    $mailSent: Boolean
    $suspendedAccount: Boolean
    $buyerEmail_Isnull: Boolean
  ) {
    docs: allDocument(
      first: $first
      after: $after
      last: $last
      before: $before
      companyId: $companyId
      order: $order
      search: $search
      issueDateTimeRange: $issueDateTimeRange
      objectId: $objectId
      scttAhtaBtpId: $scttAhtaBtpId
      buyerBranchId: $buyerBranchId
      typeLineTotal: $typeLineTotal
      lineTotal: $lineTotal
      typeTaxTotal: $typeTaxTotal
      taxTotal: $taxTotal
      typeGrandTotal: $typeGrandTotal
      grandTotal: $grandTotal
      timeSignedXmlRange: $timeSignedXmlRange
      docType: $docType
      downloadedXml: $downloadedXml
      signSuccess: $signSuccess
      hasError: $hasError
      mailSent: $mailSent
      suspendedAccount: $suspendedAccount
      buyerEmail_Isnull: $buyerEmail_Isnull
    ) {
      totalCount
      edgeCount
      edges {
        node {
          id
          docType
          objectId
          edIssueDateTime
          scttAhtaBtpId
          scttAhtaBtpName
          scttAhtaBtpStrId
          buyerBranchId
          scttAhtsStshmsTaxBasisTotalAmount
          scttAhtsStshmsTaxTotalAmount
          scttAhtsStshmsGrandTotalAmount
          timeSignedXml
          mailSent
          downloadedXml
          signedXmlUrl
          signedPdfUrl
          unsignedPdfUrl
          errors
          buyerEmail
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
